import {
  AST,
  ASTNode,
} from '@/components/smartai/OnboardInventory/OnboardInventoryContent';

type FlatASTNode = Omit<ASTNode, 'children'>;

const flattenArray = (array: ASTNode[]): FlatASTNode[] => {
  return array.reduce<FlatASTNode[]>((acc, item) => {
    const { children, ...itemWithoutChildren } = item;
    acc.push(itemWithoutChildren);

    if (children && children.length > 0) {
      acc.push(...flattenArray(children));
    }

    return acc;
  }, []);
};

export function extractAllElements(data: AST) {
  const result = flattenArray(data?.children ?? []);
  return result;
}
